export enum VDA_TYPE {
  VIRTUAL_APPLICATION = 'virtual application',
  SOFTWARE = 'software',
};

export enum RELEASE_TYPE {
  VIRTUAL_DEVICE = 'release_vda',
  VIRTUAL_APP = 'release_va',
  SOFTWARE = 'release_software',
}